import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "audit-logs";

export const getAuditLogList = (
	tenantKey: any,
	identifierData: any,
	type: any,
	auditlogFilter: Array<any>
) => {
	return new Promise((resolve, reject) => {
		AuthHeader.headers = { ...AuthHeader.headers, tenantKey };
		axios
			.get(`${url}/${tenantKey}/${apiURL}/${type}`, {
				params: {
					identifierData,
					auditlogFilter,
				},
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const getAuditLogListV2 = (
	filter: {},
	tenantKey: string | null = null
) => {
	return new Promise((resolve, reject) => {
		AuthHeader.headers = { ...AuthHeader.headers, tenantKey };
		const api_url = tenantKey
			? `${url}/${tenantKey}/${apiURL}`
			: `${url}/${apiURL}`;
		axios
			.get(api_url, {
				params: {
					filter: JSON.stringify(filter),
					sort: JSON.stringify({ created_at: -1 }),
				},
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
